<style scoped>
.two-part {
  width: 50%;
  padding: 10px;
}
.form-group:not([class*=' col-']) {
  width: 100%;
  width: 33.333333%;
  padding-left: 5px;
  padding-right: 5px;
  padding-top: -5px;
  padding-bottom: -5px;
}
</style>

<template>
  <div>
    <div class="d-flex justify-content-between" style="margin-bottom: 10px">
      <div>
        <p style="font-size: 12px">
          <b-icon icon="info" variant="success"></b-icon>&nbsp;Select table row
          for more option.
        </p>
      </div>
      <b-button-group v-if="editableOps">
        <b-button
          variant="outline-primary"
          size="sm"
          @click="refreshTableAndCombo"
          >Refresh</b-button
        >
      </b-button-group>
    </div>
    <DxDataGrid
      id="logging-interval-grid"
      ref="loggingIntervalGrid"
      :data-source="loggingIntervalDataSource"
      :show-borders="false"
      :show-column-lines="false"
      :show-row-lines="true"
      column-resize-mode="nextColumn"
      :allow-column-reordering="true"
      :allow-column-resizing="true"
      :cell-hint-enabled="true"
      :word-wrap-enabled="true"
      :column-auto-width="false"
      :column-width="100"
      :height="300"
      date-serialization-format="yyyy-MM-ddTH:mm"
      @row-inserted="savedRows"
      @row-updated="updatedRows"
      @row-removed="removedRows"
    >
      <DxPaging :enabled="false"/>
      <DxSelection mode="single"/>
      <DxScrolling column-rendering-mode="virtual"/>
      <DxEditing
          :allow-updating="true"
          :allow-adding="true"
          :allow-deleting="true"
          :use-icons="true"
          mode="row"/>
      <DxColumn v-for="column in tableFields" :key="column.key" :data-field="column.key" :caption="column.label" :data-type="column.type" />
    </DxDataGrid>
  </div>
</template>

<script>
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxEditing,
  DxFormItem,
  DxLookup,
  DxSelection,
  DxScrolling
} from 'devextreme-vue/data-grid'
import notify from "devextreme/ui/notify"
import { formMethods } from '@state/helpers'
import CustomStore from 'devextreme/data/custom_store'
import mapApiUrl from '@/src/utils/api-mapper'
import axios from 'axios'
import qs from 'querystring'

export default {
  components: { 
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxEditing,
    DxSelection,
    DxScrolling,
    // DxFormItem,
    DxLookup,
    // DxForm,
    // DxSimpleItem,
    // DxGroupItem,
  },
  props: {
    submitId: {
      type: Number,
      default: undefined,
    },
    editableOps: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      loggingIntervalDataSource: null,
      selectedRow: [],
      listItem: [],
      perPage: 10,
      tableBusy: false,
      currentPage: 1,
      loggingIntervalIsLoading: false,
      tableFields: [
        { key: 'runNo', label: 'Run no', type: 'number' },
        { key: 'logDateTime', label: 'Log date time', type: 'date' },
        { key: 'intervalLogged', label: 'Interval logged', type: 'number' },
        { key: 'mdTop', label: 'MD top', type: 'number' },
        { key: 'mdBase', label: 'MD base', type: 'number' },
        { key: 'rigUp', label: 'Rig up ', type: 'date' },
        { key: 'rigDown', label: 'Rig down ', type: 'date' },
        { key: 'totalTime',  label: 'Total time', type: 'number' },
        { key: 'lostTime', label: 'Lost time', type: 'number' },
        { key: 'sondeUp', label: 'Sonde up ', type: 'date' },
        { key: 'bht', label: 'BHT', type: 'number'},
        { key: 'comments', label: 'Comments', type: 'string' },
      ],
      selectedAction: '',
      form: [],
      show: false,
    }
  },

  computed: {
    totalRows: function () {
      return this.listItem.length
    },
  },

  watch: {
    submitId: function (val) {
      this.refreshGrid()
    },
  },

  created: function () {
    this.init()
  },

  methods: {
    ...formMethods,
    init() {
      this.loggingIntervalDataSource = new CustomStore({
        key: 'intId',
        load: () => {
          const url = mapApiUrl('/api/form/activity/logging/interval/review/submit')
          const params = {submitId: this.submitId, status: 1}
          return axios.get(url, {params: params}).then(response => response.data.data)
        },
        onLoaded: (result) => {
            // Result is the array of data received from your backend
            console.log("Store received this data:", result);
            
            // Check if the first item actually contains your key
            if (result && result.length > 0) {
                console.log("Sample item structure:", result[0])
            }
        },
        insert: (values) => {
          values.submitId = this.submitId
          const url = mapApiUrl('/api/form/activity/logging/interval/add')
          return axios.post(url, qs.stringify(values)).then(response => response) 
        },
        update: (key, values) => {
          values.submitId = this.submitId
          values.intId = key
          const url = mapApiUrl('/api/form/activity/logging/interval/add')
          return axios.post(url, qs.stringify(values)).then(response => response) 
        },
        remove: (key) => {
          const url = mapApiUrl('/api/form/activity/logging/interval/remove')
          return axios.delete(url, {params: {intId: key}})
        },
      })
    },
    refreshGrid() {
      this.$refs.loggingIntervalGrid.instance.refresh()
    },
    savedRows(e) { // e.data value is whatever customstore object returns
      notify({ message: `Logging interval data has been recorded.`, width: 500 }, 'success', 3000)
    },
    updatedRows(e) { // e.data value is whatever customstore object returns
      notify({ message: `Logging interval data has been updated.`, width: 500 }, 'success', 3000)
    },
    removedRows(e) { // e.data value is whatever customstore object returns
      notify({ message: `Logging interval data has been removed.`, width: 500 }, 'success', 3000)
    },
    refreshTableAndCombo() {
      this.listItem = []
      if (this.submitId) {
        this.tableBusy = true
        this.getActivityLoggingInterval({
          params: { submitId: this.submitId },
        }).then((resp) => {
          this.listItem = resp.data.data
          this.tableBusy = false
        })
      } else {
        console.log('No report selected')
      }
      this.loadAllCombo()
    },
    loadAllCombo() {},
    onRowSelected(item) {
      if (item.length === 0) {
        this.selectedRow = []
        this.$refs.tableDataLoggingInterval.clearSelected()
        return
      }
      this.selectedRow = item
      this.form = item[0]
    },
    makeToast(msg) {
      this.$bvToast.toast(msg, {
        title: 'Notification',
        autoHideDelay: 5000,
        appendToast: false,
      })
    },
    saving(e) {
      let rowData = {}
      if (Array.isArray(e.changes)) {
        rowData = {...e.changes[0].data}        
      } else {
        rowData = {...e.changes.data}
      }
      delete rowData.intId
      rowData.submitId = this.submitId
      this.addActivityLoggingInterval({ params: rowData }).then((resp) => {
          this.retrieveDataTable()
          notify({ message: 'Data has been recorded.', width: 300 }, 'success', 5000)
      })
    },
    askServerToRemoveData() {
      if (this.selectedRow.length > 0) {
        const data = { ...this.selectedRow[0] }
        this.removeActivityLoggingInterval({ params: data }).then((resp) => {
          this.refreshTableAndCombo()
          this.closeModalRemove()
          this.makeToast('Remove data logging intervals details success.')
        })
      }
    },
  },
}
</script>